import { DEFAULT_ERROR_MESSAGE } from './constants';

/**
 * This is implemented by ClientRequestError, which is also widely imported, and looks to be a successor.
 * Is it safe to replace-all this with ClientResponseError and make it private?
 * I don't have the context but if it's safe I think it's an easy change that would be worthwhile in the short and long term.
 *
 * - Travis
 */
export class ClientErrorWithResponse<T = any> extends Error {
  statusCode: number;
  response: T;

  constructor(message: string = DEFAULT_ERROR_MESSAGE) {
    super(message);
    Object.setPrototypeOf(this, ClientErrorWithResponse.prototype);
  }
}
